@if (isLoading()) {
} @else {
  <edu-overlay-menu
    menuClass="bg-popover border border-line-strong rounded-lg shadow-lg p-2 min-w-48"
    wrapperClass="rounded-lg"
  >
    <div
      slot="trigger"
      class="hover:bg-hover active:bg-active flex w-full cursor-pointer items-center gap-4 rounded-lg px-3 py-2"
    >
      <div class="h-10 shrink-0">
        @if (avatarUrl()) {
          <img
            [src]="avatarUrl()"
            [alt]="'globals.avatar' | transloco"
            class="bg-muted border-line h-full rounded-full border"
          />
        }
      </div>
      <div class="flex grow flex-col overflow-hidden">
        <div class="text-fg truncate font-medium">{{ firstname() }} {{ lastname() }}</div>
        <div class="text-fg/80 -mt-1 truncate text-sm">{{ email() }}</div>
      </div>
      <div class="text-fg-muted flex h-5 w-5 shrink-0 items-center justify-center">
        <edu-icon [icon]="Icons.CHEVRON_DOWN" />
      </div>
    </div>

    <div slot="menu" class="flex flex-col gap-0.5" *transloco="let t">
      <button
        type="button"
        class="text-fg hover:bg-hover flex w-full cursor-pointer items-center gap-3 rounded-lg px-3 py-2 text-left text-sm leading-none!"
        (click)="toggleTheme()"
      >
        @if (theme.isLight()) {
          <edu-icon [icon]="Icons.THEME_DARK" iconClasses="text-lg" />
          {{ t('components.compounds.userMenu.darkMode') }}
        } @else {
          <edu-icon [icon]="Icons.THEME_LIGHT" iconClasses="text-lg" />
          {{ t('components.compounds.userMenu.lightMode') }}
        }
      </button>
      <button
        type="button"
        class="text-fg hover:bg-hover flex w-full cursor-pointer items-center gap-3 rounded-lg px-3 py-2 text-left text-sm leading-none!"
        (click)="handleLogout()"
      >
        <edu-icon [icon]="Icons.LOGOUT" iconClasses="text-lg" />
        {{ t('components.compounds.userMenu.logout') }}
      </button>
    </div>
  </edu-overlay-menu>
}
